import { CancelOutlined, CheckCircleOutline } from "@mui/icons-material";
import { Box } from "@mui/material";

type Props = {
  status: "Completed" | "Scheduled" | "Canceled";
};

export function PickStatusIcon({ status }: Props) {
  const isComplete = status.toLowerCase() === "completed";
  const isCanceled = status.toLowerCase() === "canceled";

  if (isCanceled) {
    return (
      <CancelOutlined
        sx={{ color: "autostoreRed.main" }}
        aria-label="Canceled outline icon"
        role="img"
        aria-hidden={false}
      />
    );
  }

  if (isComplete) {
    return (
      <CheckCircleOutline
        aria-label="Complete outline icon"
        sx={{ color: "success.main" }}
        role="img"
        aria-hidden={false}
      />
    );
  }
  return <Box width="24px" height="24px" />;
}
